import {isNotEmpty} from 'ramda';

import {PurchasePriceRuleScope} from '@dms/api/sales';

const SCOPE_PART_SEPARATOR = ' → ';
const LABEL_SEPARATOR = ', ';

interface FormatPurchasePriceRuleScopeParams {
  scope: PurchasePriceRuleScope;
  getLabel: (key: string) => string;
  allModelFamiliesLabel: string;
  allTrimsLabel: string;
}

/**
 * Formats a rule scope as `makes → model families → trims`. An empty list of model families or
 * trims means the rule is not narrowed on that level.
 */
export const formatPurchasePriceRuleScope = (params: FormatPurchasePriceRuleScopeParams) => {
  const joinLabels = (keys: string[], emptyLabel: string) =>
    isNotEmpty(keys) ? keys.map(params.getLabel).join(LABEL_SEPARATOR) : emptyLabel;

  return [
    params.scope.makes.map(params.getLabel).join(LABEL_SEPARATOR),
    joinLabels(params.scope.modelFamilies, params.allModelFamiliesLabel),
    joinLabels(params.scope.trims, params.allTrimsLabel),
  ]
    .filter(isNotEmpty)
    .join(SCOPE_PART_SEPARATOR);
};
